import { getTargetMonth } from '../../helpers';

const getGoalCopy = ({ firstName, weight, goalWeight }) => {
  const nameStr = (name) => (name ? `, ${name}` : '');

  if (weight && goalWeight) {
    const weightToLose = Math.max(0, weight - goalWeight);
    const targetMonth = getTargetMonth();
    return [
      `Down ${weightToLose} pounds by ${targetMonth}!`,
      `Let’s get there together${nameStr(firstName)}!`,
    ];
  } else {
    return [`Let’s lose weight and keep it off together${nameStr(firstName)}`];
  }
};

export function GoalText({ gameProfile }) {
  const copy = getGoalCopy(gameProfile?.onboardingInformation || {});
  return copy.map((c) => <div key={c}>{c}</div>);
}
